module.exports = __webpack_public_path__ + "img/lsp-workshop-step-2.6555dcfd.jpg";